import { Card, Col, Divider, Row, Typography } from 'antd';
import React from 'react';
import getActions from '../actions/courseStepEnrolledActions';
import SubmissionsList from './submissionsList';
import ResourcesList from './resourcesList';

const { Title, Text } = Typography;

const Lesson = ({
    lesson,
    isCurrentLesson,
    userId,
    unlocked = false,
    showSubmissions = true,
}) => {
    // Students consume the course lesson-by-lesson, so only the current lesson is
    // interactive. Teachers/admins are not enrolled and have no "current" lesson, so
    // `unlocked` opens the whole course for them (read access to content + resources).
    const disabled = !(isCurrentLesson || unlocked);
    return (
        <Card
            title={
                <Title level={4} disabled={disabled}>
                    {lesson.title}
                </Title>
            }
            extra={getActions(lesson, isCurrentLesson, userId)}
        >
            <Row>
                <Col span={8}>
                    <Text disabled={disabled}>
                        {lesson.description}
                    </Text>
                </Col>
                <Col span={1}>
                    <Divider type="vertical" style={{ height: '100%' }} />
                </Col>
                <Col span={showSubmissions ? 8 : 15}>
                    <ResourcesList
                        resources={{
                            file: lesson.file_resources,
                            link: lesson.link_resources,
                        }}
                        disabled={disabled}
                    />
                </Col>
                {showSubmissions && (
                    <>
                        <Col span={1}>
                            <Divider type="vertical" style={{ height: '100%' }} />
                        </Col>
                        <Col span={6}>
                            <SubmissionsList
                                submissions={lesson.submissions ?? []}
                                disabled={disabled}
                            />
                        </Col>
                    </>
                )}
            </Row>
        </Card>
    );
};

export default Lesson;
